export const ADMIN_API_BASE_URL =
  import.meta.env.MODE === "production"
    ? "/api"
    : import.meta.env.VITE_API_BASE_URL ||
      `${(import.meta.env.VITE_API_URL ?? "").replace(/\/+$/u, "")}/api`;
